// @flow
import PlainMessageModal, { type PlainMessageModalProps } from './plain-message-modal';

export default PlainMessageModal;
export type { PlainMessageModalProps };
